module.exports = __webpack_public_path__ + "img/nav-icons.b87fd416.svg";